import { useStartTaskQueue } from '../hooks/useStartTaskQueue';
import { TableContext } from './TableContext';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TaskViewTableContextProvider({
  children,
  viewId,
  onRefreshSearch,
  onDelayedRefreshSearch
}) {
  const startTaskQueue = useStartTaskQueue({
    viewId
  });
  const contextValue = {
    onStartTaskQueue: startTaskQueue,
    onRefreshSearch,
    onDelayedRefreshSearch
  };
  return /*#__PURE__*/_jsx(TableContext.Provider, {
    value: contextValue,
    children: children
  });
}